// These editors sit alongside the existing feature switches. Company settings
// are live company-wide values, not part of the new-location feature template.
export const FEATURE_SETTING_EDITORS = {
  scheduling: [
    { id: "schedule-grading", title: "Schedule grading", scope: "company", group: "schedule-grading" },
    { id: "scheduling-rules", title: "Request notice & break defaults", scope: "location", group: "scheduling-rules" },
    { id: "calendar", title: "Calendar & time boundaries", scope: "location", group: "calendar" },
  ],
  time_attendance: [
    { id: "pay-periods", title: "Pay period settings", scope: "location", companyDefault: true, scopeHelp: "Company sets the schedule new locations inherit. Existing locations keep their own schedules and use future-dated changes." },
  ],
  forecasting: [
    { id: "forecasting", title: "Forecast cadence & horizon", scope: "company", group: "forecasting" },
  ],
  reporting: [
    { id: "metric-labels", title: "Metric labels", scope: "company", group: "metric-labels" },
  ],
  logbook: [
    { id: "logbook-email", title: "Daily email settings", scope: "company", group: "logbook-email" },
  ],
  labor_compliance: [
    { id: "labor-laws", title: "Jurisdictions & labor laws", scope: "location", locationEditor: true },
  ],
  team_management: [
    { id: "roles", title: "Roles, departments & stations", scope: "company", presentation: "page", locationEditorId: "role-colors", scopeDescription: "Company structure & default colors", scopeHelp: "Manage departments, roles, stations, and company default colors here. Each location can override its role colors from the table." },
    { id: "role-colors", title: "Role colors", scope: "location", comparisonHidden: true },
    { id: "check-ins", title: "Check-in template", scope: "company", requiredFlags: ["check_ins_enabled"] },
  ],
  tip_pooling: [
    { id: "tip-pools", title: "Tip pool policies", scope: "company", presentation: "page", scopeDescription: "Policies assigned to locations", scopeHelp: "A policy describes the pools, time windows, sources, and points per job code once. Assign it to every location that follows it; locations with tip pooling on and no policy pool nothing." },
  ],
  training: [
    { id: "training", title: "Proficiency requirements", scope: "company", requiredFlags: ["training_enabled", "proficiency_from_lms_enabled"] },
  ],
  location_details: [
    { id: "hours", title: "Operating hours", scope: "location", locationEditor: true },
    { id: "location-details", title: "Address & phone", scope: "location", group: "location-details" },
  ],
};

export const getFeatureSettingEditors = (bucketKey, isCompanyDefault) =>
  (FEATURE_SETTING_EDITORS[bucketKey] || []).filter(
    (editor) => !isCompanyDefault || editor.scope === "company" || editor.companyDefault
  );

export const isFeatureEditorEnabled = (editor, flags) =>
  !editor.requiredFlags || editor.requiredFlags.every((flag) => Boolean(flags[flag]));
